module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABaElEQVQokX3TP0iWURQG8J9mIQjhn/icWiRqMIQSwykHIyJoEbLBpSVwtKWhIRKcmhoaai0Ioi0FbWkoiCITp5Y+o5wkI1yECsw4cV64XKKznPfe8zz3ueee5+1ot9uquIrrGCm2P+EB7pTQkjyIlziOt1jCFvoxifPYxVmsBaErif0J3MYwPlS3CcUWnuE9xrDakN/lqa26hyK+YhxvEt/RiSsYwokKPIWnmKv2xzPfi5438Q2nC8AtzGMHvXnIdFF/EutQPoqHRaEnibfRh1O4jIsF5hpGO3OxVRQOZl7LvF5Mo4kfcUBD7i0KcdWVfNmb+ILPeFxgfuF79BzgVZyrHuYjjuV3K8fYxAR+hvJCmuBQRT6J+5m3q9qNcGHjsL3sbbQC/SvCICH0uun5TI5qOYb/H2K8zfMU22/IYbnw7AX8xl0cwQEMZM8vcCmVw2UacsQrHMYjzKbKDBbRnaOLH2fjLxp/APijUid+dQDdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/duty.png
// module id = GGdS
// module chunks = 1